export default __webpack_public_path__ + "static/media/AnimalFeaturesClaws_03.585171b6.png";